import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CurrencySwitcher from './CurrencySwitcher';
import LanguageSwitcher from './LanguageSwitcher';
import '../../styles/public.css';

interface AppNavProps {
  accentColor?: string;
}

const AppNav: React.FC<AppNavProps> = ({ accentColor = '#38bdf8' }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation('landing');

  const NAV_LINKS = [
    { to: '/shop',       label: t('appNav.shop'),     icon: '🛍️', className: '' },
    { to: '/journeys',   label: t('appNav.journeys'), icon: '✈️',  className: '' },
    { to: '/globe',      label: t('appNav.globe'),    icon: '🌐', className: '' },
    { to: '/home',       label: t('appNav.home'),     icon: '🏠', className: '' },
    { to: '/africa',     label: t('appNav.africa'),   icon: '🌿', className: 'africa' },
    { to: '/china',      label: t('appNav.china'),    icon: '🏮', className: 'china' },
    { to: '/contact-us', label: t('appNav.contact'),  icon: '💬', className: '' },
  ];

  return (
    <>
      <nav className="app-nav" style={{ '--nav-accent': accentColor } as React.CSSProperties}>
        <Link to="/home" className="app-nav-brand" onClick={() => setOpen(false)}>
          <img
            src="/logos/nomadme_sourcing_trading_mark.svg"
            alt="NomadMe"
            style={{ width: 28, height: 28, borderRadius: 6, display: 'block', flexShrink: 0 }}
          />
          <span>nomad<span style={{ color: '#EA5B0C' }}>me</span></span>
        </Link>

        <div className="app-nav-links">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                `app-nav-link${link.className ? ` app-nav-link--${link.className}` : ''}${isActive ? ' app-nav-link--active' : ''}`
              }
            >
              <span>{link.icon}</span>
              <span>{link.label}</span>
            </NavLink>
          ))}
        </div>

        <div className="app-nav-right">
          <CurrencySwitcher variant="ghost" accentColor={accentColor} />
          <LanguageSwitcher />
          <Link to="/login" className="app-nav-login">
            {t('appNav.signIn')}
          </Link>
          <button
            className="app-nav-burger"
            aria-label="Menu"
            onClick={() => setOpen((v) => !v)}
          >
            <span style={{ transform: open ? 'rotate(45deg) translate(5px, 5px)' : undefined }} />
            <span style={{ opacity: open ? 0 : 1 }} />
            <span style={{ transform: open ? 'rotate(-45deg) translate(5px, -5px)' : undefined }} />
          </button>
        </div>
      </nav>

      {open && (
        <div className="app-nav-mobile">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                `app-nav-link${link.className ? ` app-nav-link--${link.className}` : ''}${isActive ? ' app-nav-link--active' : ''}`
              }
              onClick={() => setOpen(false)}
            >
              <span>{link.icon}</span>
              <span>{link.label}</span>
            </NavLink>
          ))}
          <Link to="/login" className="app-nav-link" onClick={() => setOpen(false)}>
            <span>🔐</span>
            <span>{t('appNav.signIn')}</span>
          </Link>
          <div style={{ display: 'flex', gap: 8, padding: '6px 14px' }}>
            <CurrencySwitcher variant="ghost" accentColor={accentColor} />
            <LanguageSwitcher />
          </div>
        </div>
      )}
    </>
  );
};

export default AppNav;
